import ClockIcon from '@mui/icons-material/AccessTime';
import { Button, FormControl, ListSubheader, Select, styled } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

import mainTheme from 'theme/mainTheme';

export const DealerSelectFormControl = styled(FormControl)({
  m: 1,
  height: 40,
  width: 315,
  margin: 7,
  paddingTop: 20,
  paddingLeft: 20,
});

export const DealerSelectSelect = styled(Select)({
  backgroundColor: 'white',
  '& .MuiSelect-menu': {
    color: 'gray',
  },
  height: 30,
});

export const DealerSelectListSubheader = styled(ListSubheader)({
  width: '100%',
  position: 'sticky',
  bottom: 0,
  backgroundColor: 'white',
  zIndex: 1,
  paddingLeft: 80,
});

export const DealerSelectCheckbox = styled(Checkbox)({
  '&:hover': {
    color: mainTheme.colors.secondary.variant4,
  },
});

export const DealerSelectOnlyButton = styled(Button)({
  color: mainTheme.colors.primary.variant2,
  '&:hover': {
    color: mainTheme.colors.secondary.variant4,
    borderColor: mainTheme.colors.secondary.variant4,
    '&:before': {
      borderWidth: '1px',
      borderRadius: '4px',
      borderColor: mainTheme.colors.secondary.variant4,
      borderStyle: 'solid',
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 0,
    },
  },
});

export const DealerSelectClockIcon = styled(ClockIcon)({
  color: mainTheme.colors.primary.variant1,
  fontSize: 20,
  marginRight: '3px',
});

export const DealerSelectResetButton = styled(Button)({
  color: mainTheme.colors.primary.variant1,
  '&:hover': {
    color: mainTheme.colors.secondary.variant4,
    '& .MuiSvgIcon-root': {
      color: mainTheme.colors.secondary.variant4,
    },
  },
});

export const DealerSelectApplyButton = styled(Button)({
  color: 'white',
  backgroundColor: mainTheme.colors.primary.variant1,
  '&:hover': {
    backgroundColor: mainTheme.colors.secondary.variant4,
  },
});
